import { CloudPlatform } from '../models/datapoint/cloudPlatform';

export class CloudPlatformsUtil {
    private static instance: CloudPlatformsUtil;

    static getInstance() {
        if (!CloudPlatformsUtil.instance) {
            CloudPlatformsUtil.instance = new CloudPlatformsUtil();
        }

        return CloudPlatformsUtil.instance;
    }

    /**
    * CloudPlatformsUtil is a singleton class, so use CloudPlatformsUtil.getInstance() method instead of creating new CloudPlatformsUtil().
    */
    private constructor() {

    }

    copyFrom(cloudPlatforms: Array<CloudPlatform>, cloudPlatformsTmp: Array<CloudPlatform>): void {

    }

    compare(cloudPlatforms: Array<CloudPlatform>, cloudPlatformsTmp: Array<CloudPlatform>): string {

        return '';
    }
}